const aquarius = {
  aquarius:
    'Aquarius-Aquarius compatibility is marked by a strong bond of shared intellect and vision, creating a stimulating and progressive partnership.',
  aries:
    'Aquarius and Aries exhibit moderate compatibility, blending independence with camaraderie, needing mutual respect for individuality.',
  cancer:
    'Aquarius and Cancer share moderate compatibility, balancing emotion with intellect, fostering a dynamic and evolving bond.',
  capricorn:
    "Aquarius and Capricorn share good compatibility, balancing Capricorn's tradition with Aquarius' innovation, fostering growth through shared values and vision.",
  gemini:
    'Aquarius and Gemini exhibit strong compatibility, sharing intellect and innovation, creating an exciting and progressive relationship.',
  leo: "Aquarius and Leo exhibit moderate compatibility, balancing Leo's individuality with Aquarius' unity, requiring mutual appreciation for uniqueness.",
  libra:
    'Aquarius and Libra share very compatible traits, with social grace and ideals, fostering a harmonious and progressive partnership.',
  pisces:
    "Aquarius and Pisces exhibit fair compatibility, balancing Aquarius' idealism with Pisces' empathy, fostering understanding and mutual growth.",
  sagittarius:
    "Aquarius and Sagittarius exhibit a strong partnership, balancing Sagittarius' independence with Aquarius' unity, creating a progressive and harmonious bond.",
  scorpio:
    "Aquarius and Scorpio share fair compatibility, balancing Scorpio's depth with Aquarius' innovation, requiring mutual respect and appreciation.",
  taurus:
    'Aquarius and Taurus share moderate compatibility, balancing tradition with innovation, needing mutual appreciation for different approaches.',
  virgo:
    'Aquarius and Virgo form a good match, offering intellectual stimulation and adaptability, blending practicality with innovation.',
};

const aries = {
  aquarius:
    'Aries and Aquarius exhibit moderate compatibility, blending independence with camaraderie, needing mutual respect for individuality.',
  aries:
    'Aries-Aries compatibility is marked by a powerful bond of shared energy and similar traits, leading to a dynamic and passionate relationship.',
  cancer:
    'Aries and Cancer experience decent harmony, blending action-oriented Aries with emotionally deep Cancer for a blend of energy and sensitivity.',
  capricorn:
    'Aries and Capricorn face challenges due to differences in impulsiveness and practicality, requiring patience and understanding.',
  gemini:
    'The Aries-Gemini connection is characterized by lively communication and intellectual stimulation, creating a dynamic and engaging relationship.',
  leo: 'Aries and Leo form a strong partnership, combining passion with vitality, resulting in a fiery and enthusiastic connection.',
  libra:
    "Aries-Libra compatibility is moderate, balancing Aries' assertiveness with Libra's diplomacy, needing mutual respect and compromise.",
  pisces:
    "Aries-Pisces connection is moderate, combining Aries' drive with Pisces' dreaminess, requiring understanding of each other's realities.",
  sagittarius:
    'Aries and Sagittarius share a very harmonious bond, blending adventurous traits for an optimistic and enthusiastic partnership.',
  scorpio:
    "Aries-Scorpio connection exhibits moderate compatibility, balancing Aries' passion with Scorpio's intensity, requiring trust and depth.",
  taurus:
    "Aries and Taurus exhibit moderate compatibility, with Aries' assertiveness needing to find harmony with Taurus' stability for a balanced partnership.",
  virgo:
    "Aries and Virgo share fair harmony, with Aries' confidence complementing Virgo's practicality, requiring balance and understanding.",
};

const cancer = {
  aquarius:
    'Cancer and Aquarius share moderate compatibility, balancing emotion with intellect, fostering a dynamic and evolving bond.',
  aries:
    'Cancer and Aries experience decent harmony, blending action-oriented Aries with emotionally deep Cancer for a blend of energy and sensitivity.',
  cancer:
    'Cancer-Cancer compatibility is marked by a strong bond of deep emotional understanding, fostering a compassionate and nurturing bond.',
  capricorn:
    "Cancer and Capricorn face moderate compatibility, balancing emotion with ambition, requiring understanding of each other's priorities.",
  gemini:
    "Gemini and Cancer exhibit fair harmony, needing to balance different perspectives, appreciating each other's strengths for growth.",
  leo: 'Cancer and Leo exhibit fair harmony, balancing sensitivity with assertiveness, needing mutual support and appreciation.',
  libra:
    'Cancer-Libra compatibility is challenging, balancing emotions with diplomacy, requiring understanding and communication.',
  pisces:
    'Cancer and Pisces share a strong connection, with a nurturing and intuitive bond, creating a compassionate and spiritually fulfilling relationship.',
  sagittarius:
    'Cancer and Sagittarius exhibit moderate compatibility, blending emotion with optimism, needing balance between depth and lightness.',
  scorpio:
    'Cancer and Scorpio share a very compatible bond, with emotional depth and intuition, fostering a profound and spiritually fulfilling connection.',
  taurus:
    'The Taurus-Cancer connection is good, offering emotional stability and shared values, creating a nurturing and supportive relationship.',
  virgo:
    'Cancer and Virgo share fair harmony, balancing emotions with practicality, creating a stable and supportive relationship.',
};

const capricorn = {
  aquarius:
    "Capricorn and Aquarius share good compatibility, balancing Capricorn's tradition with Aquarius' innovation, fostering growth through shared values and vision.",
  aries:
    'Capricorn and Aries face challenges due to differences in impulsiveness and practicality, requiring patience and understanding.',
  cancer:
    "Cancer and Capricorn face moderate compatibility, balancing emotion with ambition, requiring understanding of each other's priorities.",
  capricorn:
    'Capricorn-Capricorn compatibility is marked by a strong bond of shared ambition and determination, creating a stable and successful partnership.',
  gemini:
    'Capricorn and Gemini form a good match, offering intellectual stimulation and practicality, blending innovation with groundedness.',
  leo: "Capricorn and Leo form a good match, balancing Leo's ambition with Capricorn's stability, creating a supportive and ambitious partnership.",
  libra:
    "Capricorn and Libra exhibit fair harmony, balancing Libra's diplomacy with Capricorn's ambition, requiring mutual respect and compromise.",
  pisces:
    'Capricorn and Pisces face challenges due to differences in practicality and empathy, requiring understanding and compromise.',
  sagittarius:
    "Sagittarius and Capricorn share good compatibility, balancing Sagittarius' freedom with Capricorn's ambition, fostering growth through balance and support.",
  scorpio:
    "Scorpio and Capricorn exhibit moderate compatibility, balancing Scorpio's emotion with Capricorn's ambition, fostering growth through trust and dedication.",
  taurus:
    "Taurus and Capricorn form a strong partnership, grounded and ambitious together, supporting each other's goals and creating stability.",
  virgo:
    'Virgo and Capricorn share very compatible traits, with practicality and diligence, creating a stable and successful partnership.',
};

const gemini = {
  aquarius:
    'Aquarius and Gemini exhibit strong compatibility, sharing intellect and innovation, creating an exciting and progressive relationship.',
  aries:
    'The Aries-Gemini connection is characterized by lively communication and intellectual stimulation, creating a dynamic and engaging relationship.',
  cancer:
    "Gemini and Cancer exhibit fair harmony, needing to balance different perspectives, appreciating each other's strengths for growth.",
  capricorn:
    'Capricorn and Gemini form a good match, offering intellectual stimulation and practicality, blending innovation with groundedness.',
  gemini:
    'Gemini-Gemini compatibility is marked by a strong bond of shared intellectual stimulation and curiosity, fostering a dynamic and engaging relationship.',
  leo: 'Gemini and Leo face challenges balancing independence with togetherness, needing mutual respect for space and closeness.',
  libra:
    'Gemini and Libra share very compatible traits, with lively communication and harmony, creating a balanced and harmonious relationship.',
  pisces:
    'Gemini and Pisces face challenges due to differences in practicality and imagination, requiring compromise and creative solutions.',
  sagittarius:
    'Gemini and Sagittarius share a strong connection, with intellectual and social synergy, creating a stimulating and fulfilling partnership.',
  scorpio:
    "Gemini-Scorpio connection exhibits moderate compatibility, balancing emotions with logic, requiring understanding of each other's depths.",
  taurus:
    'Gemini and Taurus share moderate compatibility, blending adaptability with stability, needing mutual understanding and compromise for a balanced partnership.',
  virgo:
    'Gemini and Virgo share fair harmony, needing to balance detail-oriented and spontaneous traits, fostering mutual understanding.',
};

const leo = {
  aquarius:
    "Aquarius and Leo exhibit moderate compatibility, balancing Leos individuality with Aquarius' unity, requiring mutual appreciation for uniqueness.",
  aries:
    'Aries and Leo form a strong partnership, combining passion with vitality, resulting in a fiery and enthusiastic connection.',
  cancer:
    'Cancer and Leo exhibit fair harmony, balancing sensitivity with assertiveness, needing mutual support and appreciation.',
  capricorn:
    "Capricorn and Leo form a good match, balancing Leo's ambition with Capricorn's stability, creating a supportive and ambitious partnership.",
  gemini:
    "Capricorn and Leo form a good match, balancing Leo's ambition with Capricorn's stability, creating a supportive and ambitious partnership.",
  leo: 'Leo-Leo compatibility is marked by a strong bond of shared passion and vitality, leading to a dynamic and exciting partnership.',
  libra:
    'Leo and Libra share good understanding, with harmony and shared values, creating a balanced and harmonious relationship.',
  pisces:
    "Leo and Pisces share fair harmony, balancing Leo's creativity with Pisces' intuition, fostering a creative and spiritually fulfilling relationship.",
  sagittarius:
    'Leo and Sagittarius share a very compatible bond, with enthusiasm and optimism, fostering a dynamic and adventurous connection.',
  scorpio:
    "Leo-Scorpio connection exhibits moderate compatibility, balancing Leo's passion with Scorpio's depth, requiring trust and emotional connection.",
  taurus:
    "Taurus and Leo face challenges balancing practicality with passion, needing understanding of each other's approaches for harmony.",
  virgo:
    'Leo and Virgo exhibit fair harmony, balancing confidence with practicality, requiring mutual respect and support.',
};

const libra = {
  aquarius:
    'Aquarius and Libra share very compatible traits, with social grace and ideals, fostering a harmonious and progressive partnership.',
  aries:
    "Aries-Libra compatibility is moderate, balancing Aries' assertiveness with Libra's diplomacy, needing mutual respect and compromise.",
  cancer:
    'Cancer-Libra compatibility is challenging, balancing emotions with diplomacy, requiring understanding and communication.',
  capricorn:
    "Capricorn and Libra exhibit fair harmony, balancing Libra's diplomacy with Capricorn's ambition, requiring mutual respect and compromise.",
  gemini:
    'Gemini and Libra share very compatible traits, with lively communication and harmony, creating a balanced and harmonious relationship.',
  leo: 'Leo and Libra share good understanding, with harmony and shared values, creating a balanced and harmonious relationship.',
  libra:
    'Libra-Libra compatibility is marked by a strong bond of shared social grace and harmony, creating a balanced and sociable relationship.',
  pisces:
    'Libra and Pisces face challenges balancing emotion with empathy, requiring understanding and empathy for a fulfilling bond.',
  sagittarius:
    'Libra and Sagittarius share a strong partnership, with shared social ideals and optimism, creating an enthusiastic and supportive bond.',
  scorpio:
    'Libra and Scorpio exhibit moderate connection, balancing trust with diplomacy, fostering growth through understanding and communication.',
  taurus:
    'Taurus and Libra share moderate compatibility, blending tradition with novelty, needing balance and appreciation of uniqueness.',
  virgo:
    "Virgo and Libra exhibit moderate compatibility, balancing Virgo's order with Libra's harmony, requiring mutual understanding and compromise.",
};

const pisces = {
  aquarius:
    "Aquarius and Pisces exhibit fair compatibility, balancing Aquarius' idealism with Pisces' empathy, fostering understanding and mutual growth.",
  aries:
    "Aries-Pisces connection is moderate, combining Aries' drive with Pisces' dreaminess, requiring understanding of each other's realities.",
  cancer:
    'Cancer and Pisces share a strong connection, with a nurturing and intuitive bond, creating a compassionate and spiritually fulfilling relationship.',
  capricorn:
    'Capricorn and Pisces face challenges due to differences in practicality and empathy, requiring understanding and compromise.',
  gemini:
    'Gemini and Pisces face challenges due to differences in practicality and imagination, requiring compromise and creative solutions.',
  leo: "Leo and Pisces share fair harmony, balancing Leo's creativity with Pisces' intuition, fostering a creative and spiritually fulfilling relationship.",
  libra:
    'Libra and Pisces face challenges balancing emotion with empathy, requiring understanding and empathy for a fulfilling bond.',
  pisces:
    'Pisces-Pisces compatibility is marked by a strong bond of shared sensitivity and imagination, fostering a deep and spiritually fulfilling connection.',
  sagittarius:
    "Sagittarius and Pisces exhibit moderate compatibility, blending Sagittarius' exploration with Pisces' sensitivity, requiring mutual understanding and adaptation.",
  scorpio:
    'Scorpio and Pisces share a very compatible bond, with emotional depth and intuition, fostering a profound and spiritually fulfilling connection.',
  taurus:
    'Taurus and Pisces face challenges due to differences in practicality and sensitivity, requiring understanding and compromise.',
  virgo:
    'Virgo and Pisces exhibit moderate connection, balancing pragmatism with sensitivity, requiring mutual understanding and empathy.',
};

const sagittarius = {
  aquarius:
    "Aquarius and Sagittarius exhibit a strong partnership, balancing Sagittarius' independence with Aquarius' unity, creating a progressive and harmonious bond.",
  aries:
    'Aries and Sagittarius share a very harmonious bond, blending adventurous traits for an optimistic and enthusiastic partnership.',
  cancer:
    'Cancer and Sagittarius exhibit moderate compatibility, blending emotion with optimism, needing balance between depth and lightness.',
  capricorn:
    "Sagittarius and Capricorn share good compatibility, balancing Sagittarius' freedom with Capricorn's ambition, fostering growth through balance and support.",
  gemini:
    'Gemini and Sagittarius share a strong connection, with intellectual and social synergy, creating a stimulating and fulfilling partnership.',
  leo: 'Leo and Sagittarius share a very compatible bond, with enthusiasm and optimism, fostering a dynamic and adventurous connection.',
  libra:
    'Libra and Sagittarius share a strong partnership, with shared social ideals and optimism, creating an enthusiastic and supportive bond.',
  pisces:
    "Sagittarius and Pisces exhibit moderate compatibility, blending Sagittarius' exploration with Pisces' sensitivity, requiring mutual understanding and adaptation.",
  sagittarius:
    'Sagittarius-Sagittarius compatibility is marked by a strong connection, sharing enthusiasm and an adventurous spirit, creating an exciting and dynamic relationship.',
  scorpio:
    'Scorpio and Sagittarius face challenges balancing intensity with freedom, needing compromise and understanding.',
  taurus:
    'Taurus and Sagittarius exhibit moderate connection, blending security with exploration, needing balance between stability and adventure.',
  virgo:
    'Virgo and Sagittarius face challenges balancing detail with spontaneity, needing compromise and adaptability for growth.',
};

const scorpio = {
  aquarius:
    "Scorpio and Aquarius share fair compatibility, balancing Scorpio's depth with Aquarius' innovation, requiring mutual respect and appreciation.",
  aries:
    "Aries-Scorpio connection exhibits moderate compatibility, balancing Aries' passion with Scorpio's intensity, requiring trust and depth.",
  cancer:
    'Cancer and Scorpio share a very compatible bond, with emotional depth and intuition, fostering a profound and spiritually fulfilling connection.',
  capricorn:
    "Scorpio and Capricorn exhibit moderate compatibility, balancing Scorpio's emotion with Capricorn's ambition, fostering growth through trust and dedication.",
  gemini:
    "Gemini-Scorpio connection exhibits moderate compatibility, balancing emotions with logic, requiring understanding of each other's depths.",
  leo: "Leo-Scorpio connection exhibits moderate compatibility, balancing Leo's passion with Scorpio's depth, requiring trust and emotional connection.",
  libra:
    'Libra and Scorpio exhibit moderate connection, balancing trust with diplomacy, fostering growth through understanding and communication.',
  pisces:
    'Scorpio and Pisces share a very compatible bond, with emotional depth and intuition, fostering a profound and spiritually fulfilling connection.',
  sagittarius:
    'Scorpio and Sagittarius face challenges balancing intensity with freedom, needing compromise and understanding.',
  scorpio:
    'Scorpio-Scorpio compatibility is marked by a strong connection, sharing intensity and loyalty, fostering a deep and passionate relationship.',
  taurus:
    'Taurus and Scorpio share fair compatibility, balancing practicality with intensity, requiring mutual understanding and compromise.',
  virgo:
    "Virgo and Scorpio share fair compatibility, balancing Virgo's logic with Scorpio's intensity, creating a dynamic and insightful bond.",
};

const taurus = {
  aquarius:
    'Aquarius and Taurus share moderate compatibility, balancing tradition with innovation, needing mutual appreciation for different approaches.',
  aries:
    "Aries and Taurus exhibit moderate compatibility, with Aries' assertiveness needing to find harmony with Taurus' stability for a balanced partnership.",
  cancer:
    'The Taurus-Cancer connection is good, offering emotional stability and shared values, creating a nurturing and supportive relationship.',
  capricorn:
    "Taurus and Capricorn form a strong partnership, grounded and ambitious together, supporting each other's goals and creating stability.",
  gemini:
    'Gemini and Taurus share moderate compatibility, blending adaptability with stability, needing mutual understanding and compromise for a balanced partnership.',
  leo: "Taurus and Leo face challenges balancing practicality with passion, needing understanding of each other's approaches for harmony.",
  libra:
    'Taurus and Libra share moderate compatibility, blending tradition with novelty, needing balance and appreciation of uniqueness.',
  pisces:
    'Taurus and Pisces face challenges due to differences in practicality and sensitivity, requiring understanding and compromise.',
  sagittarius:
    'Taurus and Sagittarius exhibit moderate connection, blending security with exploration, needing balance between stability and adventure.',
  scorpio:
    'Taurus and Scorpio share fair compatibility, balancing practicality with intensity, requiring mutual understanding and compromise.',
  taurus:
    'Taurus-Taurus compatibility is marked by a strong bond of shared values and stability, creating a reliable and enduring partnership.',
  virgo:
    'Taurus and Virgo share good compatibility, with practicality and attention to detail, creating a harmonious and efficient partnership.',
};

const virgo = {
  aquarius:
    'Virgo and Aquarius form a good match, offering intellectual stimulation and adaptability, blending practicality with innovation.',
  aries:
    "Aries and Virgo share fair harmony, with Aries' confidence complementing Virgo's practicality, requiring balance and understanding.",
  cancer:
    'Cancer and Virgo share fair harmony, balancing emotions with practicality, creating a stable and supportive relationship.',
  capricorn:
    'Virgo and Capricorn share very compatible traits, with practicality and diligence, creating a stable and successful partnership.',
  gemini:
    'Gemini and Virgo share fair harmony, needing to balance detail-oriented and spontaneous traits, fostering mutual understanding.',
  leo: 'Leo and Virgo exhibit fair harmony, balancing confidence with practicality, requiring mutual respect and support.',
  libra:
    "Virgo and Libra exhibit moderate compatibility, balancing Virgo's order with Libra's harmony, requiring mutual understanding and compromise.",
  pisces:
    'Virgo and Pisces exhibit moderate connection, balancing pragmatism with sensitivity, requiring mutual understanding and empathy.',
  sagittarius:
    'Virgo and Sagittarius face challenges balancing detail with spontaneity, needing compromise and adaptability for growth.',
  scorpio:
    "Virgo and Scorpio share fair compatibility, balancing Virgo's logic with Scorpio's intensity, creating a dynamic and insightful bond.",
  taurus:
    'Taurus and Virgo share good compatibility, with practicality and attention to detail, creating a harmonious and efficient partnership.',
  virgo:
    'Virgo-Virgo compatibility is marked by a strong bond of shared practicality and attention to detail, creating a harmonious and efficient partnership.',
};

export const compatibilitySummaries = {
  aquarius,
  aries,
  cancer,
  capricorn,
  gemini,
  leo,
  libra,
  pisces,
  sagittarius,
  scorpio,
  taurus,
  virgo,
};
